(function () {
  'use strict';
  var desktop = window.matchMedia('(min-width: 990px)');

  function init(menu) {
    if (menu.dataset.yhsMegaReady === 'true') return;
    var details = menu.querySelector('details');
    var summary = details && details.querySelector('summary');
    if (!summary) return;
    menu.dataset.yhsMegaReady = 'true';
    var tabs = Array.from(menu.querySelectorAll('[data-yhs-mega-tab]'));
    var panels = Array.from(menu.querySelectorAll('[data-yhs-mega-panel]'));
    var closeTimer;
    var openedByHover = false;

    function activate(tab) {
      if (!tab) return;
      tabs.forEach(function (candidate) {
        var active = candidate === tab;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-selected', String(active));
        candidate.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function (panel) { panel.hidden = panel.id !== tab.dataset.panelId; });
    }
    function cancelClose() { window.clearTimeout(closeTimer); }
    function setOpen(open) {
      cancelClose();
      if (open && !desktop.matches) return;
      if (open) {
        document.querySelectorAll('[data-yhs-mega-menu]').forEach(function (other) {
          if (other !== menu && other.yhsClose) other.yhsClose();
        });
        var header = menu.closest('.header-wrapper');
        if (header) document.documentElement.style.setProperty('--header-bottom-position-desktop', Math.ceil(header.getBoundingClientRect().bottom) + 'px');
      }
      details.open = open;
      summary.setAttribute('aria-expanded', String(open));
      menu.classList.toggle('is-open', open);
      if (!open) openedByHover = false;
    }
    menu.yhsClose = function () { setOpen(false); };
    activate(tabs.find(function (tab) { return tab.getAttribute('aria-selected') === 'true'; }) || tabs[0]);

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      // A pointer click immediately following hover keeps the opened menu usable.
      var keepHoverOpen = openedByHover && event.detail > 0;
      setOpen(keepHoverOpen || !details.open);
      openedByHover = false;
    });
    menu.addEventListener('pointerenter', function (event) {
      cancelClose();
      if (event.pointerType !== 'touch' && desktop.matches && menu.dataset.openOnHover === 'true' && !details.open) {
        setOpen(true);
        openedByHover = true;
      }
    });
    menu.addEventListener('pointerleave', function () {
      if (menu.contains(document.activeElement)) return;
      closeTimer = window.setTimeout(function () { setOpen(false); }, 180);
    });
    menu.addEventListener('focusin', cancelClose);
    menu.addEventListener('focusout', function () {
      window.setTimeout(function () { if (!menu.contains(document.activeElement)) setOpen(false); }, 0);
    });
    details.addEventListener('toggle', function () {
      summary.setAttribute('aria-expanded', String(details.open));
      menu.classList.toggle('is-open', details.open);
    });
    tabs.forEach(function (tab, index) {
      tab.addEventListener('pointerenter', function () { activate(tab); });
      tab.addEventListener('focus', function () { activate(tab); });
      tab.addEventListener('click', function () { activate(tab); });
      tab.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); tabs[next].focus(); }
      });
    });
    document.addEventListener('pointerdown', function (event) {
      if (details.open && !menu.contains(event.target)) setOpen(false);
    });
    menu.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && details.open) {
        event.preventDefault();
        event.stopPropagation();
        setOpen(false);
        summary.focus();
      }
    });
  }
  function initAll() {
    document.querySelectorAll('[data-yhs-mega-menu]').forEach(function (menu) {
      init(menu);
      if (!desktop.matches && menu.yhsClose) menu.yhsClose();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  desktop.addEventListener('change', initAll);
})();
